import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useEffect } from 'react';
import { compose } from 'redux';
import { initialOptions, ownCurrentOptions, isSimilarOptionChecked } from '../StructureOptionsSelecors';
import { showMore } from './StructureOptionsDialogSelectors';

import {
  updateInputValue,
  toggleRadioOption,
  toggleSubRadioOption,
  toggleCheckboxOption,
  setCurrentOptionsSameAsSaved as setCurrentOptionsSameAsSavedAction,
  updateSavedInfoWithCurrent,
} from '../StructureOptionsActions';
import { updateStructureOptionsDialog } from './StructureOptionsDialogActions';

import StructureOptionsDialog from './StructureOptionsDialog';

import withStructureOptionsHandlers from './StructureOptionsDialogHandlers';

const mapStateToProps = (state, ownProps) => ({
  initialOptions: initialOptions(state),
  ownCurrentOptions: ownCurrentOptions(state, ownProps),
  showMore: showMore(state, ownProps),
  disableIncludeAndMoreGroup: isSimilarOptionChecked(state, ownProps),
});

const mapDispatchToProps = {
  updateInputValue,
  toggleRadioOption,
  toggleCheckboxOption,
  toggleSubRadioOption,
  updateSavedInfoWithCurrent,
  setCurrentOptionsSameAsSaved: setCurrentOptionsSameAsSavedAction,
  updateStructureOptionsDialog,
};

function StructureOptionsDialogContainer(props) {
  const { setCurrentOptionsSameAsSaved, id } = props;

  useEffect(
    () => () => {
      setCurrentOptionsSameAsSaved(id);
    },
    [setCurrentOptionsSameAsSaved, id]
  );

  return <StructureOptionsDialog {...props} />;
}
StructureOptionsDialogContainer.propTypes = {
  setCurrentOptionsSameAsSaved: PropTypes.func,
  id: PropTypes.string,
};

const EnhancedStructureOptionsDialog = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStructureOptionsHandlers
)(StructureOptionsDialogContainer);

export default EnhancedStructureOptionsDialog;
